<template>
  <div class="video-container">
    <h1 class="text--center my-3">How Guiomentor can help you?</h1>
    <youtube-media :player-width="$vuetify.breakpoint.xs ? null : 800" :video-id="videoId"></youtube-media>
  </div>
</template>

<script>
export default {
    data: () => ({
        videoId: "kyiM6ZNQRWI"
    })
};
</script>
<style lang="scss">
.video-container {
    text-align: center;
}
</style>